<template>
    <div>
        <ListingList 
            @edit="handleEdit" 
            title="Listings"
            description="Manage all listings on the platform"
            type="buy_only"
            :editable="true"
            @view="handleView"
        />
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import ListingList from './ListingList.vue';

const router = useRouter();

const handleEdit = (id) => {
    localStorage.setItem('temp_editing_listing_id', Number(id));
    router.push({
        name: 'listing-edit'
    });
}

const handleView = (id) => {
    router.push({
        name: 'item-detail',
        params: {
            id: id
        }
    });
}
</script>